import React, { createContext, useContext, useState } from "react";

type QuoteItem = { name: string; quantity: number };

interface AccumulateContextType {
    quoteItems: QuoteItem[];
    setQuoteItems: React.Dispatch<React.SetStateAction<QuoteItem[]>>;
}

const AccumulateContext = createContext<AccumulateContextType | undefined>(undefined);

export const AccumulateProvider = ({ children }: { children: React.ReactNode }) => {
    const [quoteItems, setQuoteItems] = useState<QuoteItem[]>([]);
    return (
        <AccumulateContext.Provider value={{ quoteItems, setQuoteItems }}>
            {children}
        </AccumulateContext.Provider>
    );
};

export const useAccumulate = () => {
    const context = useContext(AccumulateContext);
    if (!context) throw new Error("useAccumulate must be used within AccumulateProvider");
    return context;
};